import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import Row from '../../UI/Row';
import { NavigationHoverImage } from './NavigationHoverImage';
import { HoverImageColumn } from './styled/HoverBoxImage';
import { pageMaxWidth } from '../../mediaQueries';
import { useUrlBuilder } from '../../../hooks/useUrlBuilder';
import { NavigationDesignersAlphabet } from './NavigationDesignersAlphabet';
import { NavigationLinks } from './NavigationLinks';

const NavigationContent = ({ values, hoverImage, hidden, sales = false }) => {
  const { localized } = useUrlBuilder();

  return (
    <>
      <div className={`hover-box${hidden ? ' hidden' : ''}`}>
        <div className="navigation-content-container">
          <div style={{ flex: 0.5 }}>
            <NavigationLinks
              color={sales ? '#F25C5E' : 'black'}
              links={values.children}
              title={values.name}
              url={values.url}
            />
          </div>
          <div style={{ flex: 0.5 }}>
            {!isEmpty(values.featuredDesigners) && (
              <NavigationLinks color="black" links={values.featuredDesigners} title={values.featuredLabel} />
            )}
            {values.name.toLowerCase() === 'designers' && <NavigationDesignersAlphabet url={values.url} />}
          </div>
          <Row justifyContent="flex-end">
            <HoverImageColumn>
              {!hidden && <NavigationHoverImage {...hoverImage} hoverHref={localized(`${hoverImage.a_href}`)} />}

              <a
                href={localized(`${hoverImage.a_href}`)}
                style={{ fontSize: '15px', marginTop: '15px', textDecoration: 'underline' }}
              >
                Shop now
              </a>
            </HoverImageColumn>
          </Row>
        </div>
      </div>
      <style jsx>
        {`
          .hover-box {
            color: white;
            z-index: 100 !important;
            top: 155px;
            left: 0;
            position: fixed;
            background: white;
            width: 100%;
            height: 440px;
          }

          .hover-box.hidden {
            display: none;
          }

          .navigation-content-container {
            display: flex;
            max-width: ${pageMaxWidth};
            margin: 0 auto;
            padding: 20px 20px 0;
            justify-content: space-between;
          }

          @media (min-width: 1280px) {
            .navigation-content-container {
              padding: 20px 0 0;
            }
          }
        `}
      </style>
    </>
  );
};

NavigationContent.propTypes = {
  values: PropTypes.object.isRequired,
  applyNewInSales: PropTypes.bool,
  department: PropTypes.string.isRequired,
  hoverLeftImg: PropTypes.objectOf(
    PropTypes.shape({
      a_href: PropTypes.string,
      alt: PropTypes.string,
      folder: PropTypes.string,
      heading: PropTypes.string,
      image: PropTypes.string,
      img_name: PropTypes.string,
      md5: PropTypes.string,
      title: PropTypes.string,
    }),
  ),
  hoverImage: PropTypes.objectOf(
    PropTypes.shape({
      a_href: PropTypes.string,
      alt: PropTypes.string,
      folder: PropTypes.string,
      heading: PropTypes.string,
      image: PropTypes.string,
      img_name: PropTypes.string,
      md5: PropTypes.string,
      title: PropTypes.string,
    }),
  ),
  sales: PropTypes.bool,
  newIn: PropTypes.bool,
  hidden: PropTypes.bool,
};

export default NavigationContent;
